<template>
  <div class="foreground-right">
    <image-layer class="main" />
    <image-layer class="top-leaf" />
    <image-layer class="bottom-leaf" />
  </div>
</template>

<script>
import ImageLayer from './ImageLayer.vue'

export default{
  name: 'foreground-right',
  components: {
    'image-layer': ImageLayer
  }
}
</script>

<style lang="scss">
/** foreground-right **/
@import '../../theme';
@import './util';

// You may need to play with these values in order to get a more "realistic" sway.
// You could try adding a rotation or increasing/decreasing the skew amount.
// The length of the animation will also make a big difference in how realistic it feels.
@keyframes top-leaf-sway {
  from {
    transform: skewY(0deg);
  }
  to {
    transform: skewY(3deg);
  }
}

@keyframes bottom-leaf-sway {
  from {
    transform: skewY(-2deg); 
  }
  to {
    transform: skewY(0deg);
  }
}

// Basic styles for each layer. The image should be something like "foreground-right-main-blurred".
// The position should be the position used for the smallest file size.
@mixin cropped-layer($image, $position, $size:auto) {
  $file-name: "../../assets/home/#{$image}-cropped";
  $file-extension: "png";
  @include layer-image("#{$file-name}_1013x570.#{$file-extension}", $position, $size);
  @include media-breakpoint-up(sm) {
    background-image: url("#{$file-name}_1191x670.#{$file-extension}");
  }
  @include media-breakpoint-up(md) {
    background-image: url("#{$file-name}_1820x1024.#{$file-extension}");
  }
  @include media-breakpoint-up(lg) {
    background-image: url("#{$file-name}_2040x1148.#{$file-extension}");
  }
}

$right-close: -200px;
$right-medium: -300px;
$right-far: -400px;

.mountain-scene {
  .main {
    @include absolute-fill;
    .top {
      // The position passed to `cropped-layer` is very specific. Each layer should
      // be shifted right by the same value and that value will depend on the screen width.
      @include cropped-layer("foreground-right-main-blurred", bottom right $right-medium, 780px 742px);
    }
    .bottom {
      @include cropped-layer("foreground-right-main", bottom right $right-medium, 780px 742px);
    }

    .top, .bottom {
      @include media-breakpoint-up(sm) {
        background-position: bottom right $right-close;
      }

      @include media-breakpoint-up(md) {
        background-position: bottom right $right-far;
      }

      @include media-breakpoint-up(lg) {
        background-position: bottom right $right-far;
      }

      @include media-breakpoint-up(xl) {
        background-position: bottom right $right-medium;
      }

      @include media-breakpoint-up(xxl) {
        background-position: bottom right;
      }
    }
  }

  .top-leaf {
    @include absolute-fill;
    transform-origin: bottom right;
    // Changing the animation speed in the sway animations will have a large affect
    // on how realistic the swaying feels. I've also used a delay to make sure
    // the branches don't sway in unison.
    animation: top-leaf-sway 3.5s ease-in-out 3s infinite alternate;
    .top {
      // All of the leaf images will need to be shifted vertically from the bottom
      // a very specific amount because I've cropped those images to be as small as possible.
      // For this image, I've shifted the image up 251px.
      @include cropped-layer("foreground-right-top-leaf-blurred", bottom 251px right $right-medium, 780px 365px);
    }
    .bottom {
      @include cropped-layer("foreground-right-top-leaf", bottom 251px right $right-medium, 780px 365px);
    }

    .top, .bottom {
      @include media-breakpoint-up(sm) {
        background-position: bottom 294px right $right-close;
      }

      @include media-breakpoint-up(md) {
        background-position: bottom 452px right $right-far;
      }

      @include media-breakpoint-up(lg) {
        background-position: bottom 353px right $right-far;
      }

      @include media-breakpoint-up(xl) {
        background-position: bottom 353px right $right-medium;
      }

      @include media-breakpoint-up(xxl) {
        background-position: bottom 353px right;
      }
    }
  }

  .bottom-leaf {
    @include absolute-fill;
    transform-origin: bottom right;
    animation: bottom-leaf-sway 3s ease-in-out infinite alternate;
    .top {
      @include cropped-layer("foreground-right-bottom-leaf-blurred", bottom 107px right $right-medium, 780px 320px);
    }
    .bottom {
      @include cropped-layer("foreground-right-bottom-leaf", bottom 107px right $right-medium, 780px 320px);
    }

    .top, .bottom {
      @include media-breakpoint-up(sm) {
        background-position: bottom 125px right $right-close;
      }

      @include media-breakpoint-up(md) {
        background-position: bottom 193px right $right-far;
      }

      @include media-breakpoint-up(lg) {
        background-position: bottom 215px right $right-far;
      }

      @include media-breakpoint-up(xl) {
        background-position: bottom 215px right $right-medium;
      }

      @include media-breakpoint-up(xxl) {
        background-position: bottom 215px right;
      }
    }
  }
}
</style>
